import { resource, IPromise } from 'angular';
import { iUploadedFile } from '@/interfaces/files';
import axios from 'axios';

export interface IUploadsApiResource extends resource.IResourceClass<resource.IResource<iUploadedFile>> {
    uploadFile(file: string | object, path: string, isDocument: boolean): IPromise<iUploadedFile>;
}

(function (angular) {
    'use strict';

    angular.module('app')
        .service('UploadsApi', UploadsApi);

    UploadsApi.$inject = [
        'settings',
        '$resource',
        'Upload',
        '$q',
        'extendResource'
    ];

    function UploadsApi(
        settings,
        $resource,
        Upload,
        $q,
        extendResource
    ) {
        var resource = $resource(settings.apiBase + '/uploads', {}, {});

        /**
         * Uploads an file using the ngUpload library
         *
         * @param {string/object} file - base64 string for image, file object for document
         * @param {string} path - ?
         * @param {boolean} isDocument - whether this is a file
         * (ie. not an image) this isn't ideal but it means less refactoring
         * @return {promise}
         */
        function uploadFile(file, path, isDocument) {
            var deferred = $q.defer();
            var data = isDocument ? {
                upload: file,
                // path: path,
            } : {
                data: file,
                path: path,
            };

            // Technically we should reject if there's no file, but since this function is always called it just passively resolves
            if (!file || !path) {
                deferred.resolve(undefined);
            } else {
                // upload the image
                Upload.upload({
                    url: settings.apiBase + '/uploads' + (isDocument ? '' : '/img'),
                    data: data,
                }).then(function handleImageUploadResponse(response) {
                    deferred.resolve(response.data);
                }, function handleImageUploadError(err) {
                    deferred.reject(err);
                }, function handleImageUploadProgress(evt) {
                    var progressPercent = 100 * evt.loaded / evt.total;
                    deferred.notify(progressPercent);
                });
            }

            return deferred.promise;
        }

        function removeFile(path, id) {
            const data = { path: path, id: id };
            axios.delete(settings.apiBase + '/uploads', { data });
        }

        // Add custom uploadFile function to the resource
        resource.uploadFile = uploadFile;
        resource.uploadImage = uploadFile; // (previous method name)
        resource.removeFile = removeFile;

        return extendResource(resource);
    }

}(angular));
